
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/agentes",
      function () {
        return require("private-next-pages/collection/agentes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/agentes"])
      });
    }
  